import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    maindata: [],
    fetchedData: [],
    modalData: [],
    modalCustomData: [],
    selectData: {},
    modalCustomVariables: [],
    modalFetchedData: [],
    customData: [],
    customVariables: [],
    uploadProgress: null,
    optimisticUpload: [],
};

export const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        setModalData: (state, action) => { state.modalData = action.payload; },
        setModalCustomData: (state, action) => { state.modalCustomData = action.payload; },
        setModalCustomVariables: (state, action) => { state.modalCustomVariables = action.payload; },
        setSelectData: (state, action) => { state.selectData = action.payload; },
        setModalFetchedData: (state, action) => { state.modalFetchedData = action.payload; },
        setFetchedMainData: (state, action) => { state.fetchedData = action.payload; },
        setMainData: (state, action) => { state.maindata = action.payload; },
        setCustomData: (state, action) => { state.customData = action.payload; },
        setCustomVariables: (state, action) => { state.customVariables = action.payload; },

        setUploadProgress: (state, action) => {
            const { temp_id, value } = action.payload;
            state.uploadProgress = {
                ...(state.uploadProgress || {}),
                [temp_id]: value
            };
        },
      
        addOptimisticUpload: (state, action) => {
            if (!state.optimisticUpload.includes(action.payload.temp_id)) {
                state.optimisticUpload.push(action.payload.temp_id);
            }
        },

        removeOptimisticUpload: (state, action) => {
            state.optimisticUpload = state.optimisticUpload.filter(v => v !== action.payload.temp_id);
        },
    }
});

export const {
    setUploadProgress,
    addOptimisticUpload,
    removeOptimisticUpload,
    setSelectData,
    setCustomData,
    setCustomVariables,
    setModalFetchedData,
    setModalData,
    setModalCustomData,
    setModalCustomVariables,
    setMainData,
    setFetchedMainData
} = cartSlice.actions;

export default cartSlice.reducer;